<template>
    <div class="dropdown">
        <a :id="'dropdown-menu-link-'+ index" class="btn dropdown-toggle" v-bind:class="{'is-invalid': !isValid, 'no-selection': !selectedOption}" @click="dropdown()" role="button" data-toggle="dropdown" aria-expanded="false"><span>{{headingTitle}}</span></a>
        <div v-if="canClear" @click="clearClicked" class="clear-area"></div>
        <div class="dropdown-menu px-1" :ref="'dropdown-' + index" :aria-labelledby="'dropdown-menu-link'+ index">
            <a v-for="option in options" :key="option.key" class="dropdown-item" @click="optionClick(option)">{{option.label}}</a>
        </div>     
    </div>
</template>
<script>

export default {
    data(){
        return{
            selectedOption: null
        }
    },
    props:{
        value:
        {
            type: String,
            default: null
        },
        index: Number,
        options:
        {
            type: Array,
            default: () => []
        },
        title:
        {
            type: String,
            default: ""
        },
        canClear:
        {
            type: Boolean,
            default: false
        },
        isValid:
        {
            type: Boolean,
            default: true
        }
    },
    computed:
    {
        headingTitle: function()
        {
            var result = this.title;

            if(this.selectedOption)
            {
                result = this.selectedOption.label;
            }

            return result;
        }
    },
    mounted: function()
    {
        if(this.value)
        {
            var defaultValue = this.value;
            this.selectedOption = this.options.find(obj => {
                return obj.key === defaultValue
            });
        }

        document.addEventListener('click', this.handleClickOutside);
    },
    methods:{
        clearClicked()
        {
            this.selectedOption = null;
        },
        dropdown() {
            // Note that for date clicks are handled by the input
            this.$refs['dropdown-'+this.index].classList.toggle('showDropdown');
        },
        optionClick(option){
            this.selectedOption = option;
            this.$refs['dropdown-'+this.index].classList.remove("showDropdown");
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                if(this.$refs['dropdown-'+this.index] !== undefined)
                {
                    this.$refs['dropdown-'+this.index].classList.remove("showDropdown");
                }
            }
        }
    },
    watch:
    {
        value: function(val)
        {
            var match = this.options.find(obj => {
                return obj.key === val
            });
            // A value whose option has not loaded yet is kept; the options watcher selects it later
            if (match || !val || this.options.length)
            {
                this.selectedOption = match || null;
            }
        },
        selectedOption: function(val)
        {
            var value = val ? val.key : null;
            this.$emit('input', value);
        },
        // Options often load after the value is set (e.g. a form prefilled from the URL): select it once it exists
        options: function(options)
        {
            if (this.value && (!this.selectedOption || this.selectedOption.key !== this.value))
            {
                var match = options.find(obj => obj.key === this.value);
                if (match) this.selectedOption = match;
            }
        }
    }  
}
</script>

<style scoped>
.no-selection
{
    color: #AAAAAA;
}

.clear-area
{
    position: absolute;
    right: 0;
    width: 40px;
    height: 100%;
    top: 0;
    cursor: pointer;
}

.dropdown-clear::after
{
    content: "x";
    display: contents;
    font-weight: bold;
}

.dropdown-toggle
{
    min-width: 125px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-color: #d8dbe0;
    border-radius: 0.25rem;
}

.dropdown-toggle.is-invalid
{
    border-color: #e55353;
}

.dropdown-toggle.is-invalid::after
{
    color: #e55353;
}

.in-front
{
    z-index: 999;
}

.showDropdown
{
    display: block;
}

</style>